import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import {MainService} from './main.service';
@Injectable({
  providedIn: 'root'
})
export class JvService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService) {
    this.httpUrl = this.main.httpUrl+"/accounts/jv";
  }


  async  getJvList(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl+'/getJvData' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async  get_Jrnl_Id_Full_Info(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl+'/getJvbyjrnlid' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async  UpdateStatus(obj:any) {
    const resp = await this.http.put<any>(this.httpUrl+'/changeStatus',obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteJV(obj:any){
    const res = await this.http.delete<any>(this.httpUrl + '/deletejv'+obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
   async approveJV(obj:any){
    const res = await this.http.post<any>(this.httpUrl + '/approvejv',obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async getworkflowlogforprint(obj:any){
    const res = await this.http.get<any>(this.httpUrl + '/getworkflowPrintData' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async getFundTransferNotesheet(obj:any){
    const res = await this.http.get<any>(this.httpUrl + '/getFundNotesheet' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
}
